<template>
  <b-modal
    :id="id"
    size="xl"
    :title="this.$translate(title)"
    hide-footer
    centered
    content-class="rounded-8"
    @show="show"
  >
    <div class="row">
      <div
        class="row"
        style="padding: 20px"
      >
        <div
          v-for="i in details"
          :key="i.value"
          class=" col-lg-6 col-sm-12 col-xs-12"
        >
          <div class="details-header">
            {{ i.name | i18n }}
          </div>
          <div class="details-value">
            {{ data[i.value] ? (i.renderRow ? i.renderRow(data) : i.render ? i.render(data[i.value]) : data[i.value]) : '-' }}
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  title: 'Details instance',
  props: {
    getPage: {
      type: Function,
      default: () => {}
    },
    onSave: {
      type: Function,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    initData: {
      type: Object,
      default: () => {}
    },
    details: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      data: {}
    };
  },

  methods: {
    async show() {
      this.data = this.initData;
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep  #add-customer .modal-dialog {
  max-width: 700px !important;
}

::v-deep  .button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

::v-deep  .details-header {
  font-weight: 500;
  font-size: 25px;
}

::v-deep  .details-value {
  margin: 10px 0;
  font-size: 18px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}
</style>
